import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

var canSearch = true;

//Module过滤器触发
export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ searchParameter: { moduleId: parameter }, componentDefaultValue });
  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}


//点击添加按钮
export function addBySection({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ currentDataKey: null, fileList: [], imagePreview: null, showModal: true, customFormSubmitting: false, componentType: 'Create', title: 'Add Stamp', copyFrom: 0, type: 0 });
  setTimeout(() => {
    pageComponent.formRef.current?.resetFields();
    pageComponent.formRef.current?.setFieldValue('Type', 0);
    pageComponent.formRef.current?.setFieldValue('Page', 0);
    pageComponent.formRef.current?.setFieldValue('X', 0);
    pageComponent.formRef.current?.setFieldValue('Y', 0);
    pageComponent.formRef.current?.setFieldValue('RotateAngle', 0);
    pageComponent.formRef.current?.setFieldValue('ScaleFactor', 1);
    pageComponent.formRef.current?.setFieldValue('Opacity', 1);
    pageComponent.formRef.current?.setFieldValue('TextInImageX', 0);
    pageComponent.formRef.current?.setFieldValue('TextInImageY', 0);
    pageComponent.formRef.current?.setFieldValue('TextAlign', 0);
    pageComponent.formRef.current?.setFieldValue('TextFont', 'Arial');
    pageComponent.formRef.current?.setFieldValue('TextFontSize', 10);
    pageComponent.formRef.current?.setFieldValue('TextFontStyle', 'Regular');
    pageComponent.formRef.current?.setFieldValue('TextColor', '#000000');
    pageComponent.formRef.current?.setFieldValue('DynamicImageWidth', 1000);
    pageComponent.formRef.current?.setFieldValue('BorderColor', '#FFC83D');
    pageComponent.formRef.current?.setFieldValue('BorderThickness', 4);
    pageComponent.formRef.current?.setFieldValue('BorderPadding', 20);
    pageComponent.formRef.current?.setFieldValue('Text', '');
    pageComponent.formRef.current?.setFieldValue('file', undefined);
    pageComponent.formRef.current?.setFieldValue('CompanyUserIdList', []);
  }, config.setTimeoutMilliSecond);
}

//点击编辑按钮
export function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({ showModal: true, customFormSubmitting: false, componentType: 'Edit', title: 'Edit Stamp' });
  httpClient
    .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
    .then(({ data }) => {
      if (data.result) {
        //把处理后的数据赋值给表单
        if (data.data.Type === 1) {
          let fileList = [];
          if (data.data.Image !== null) {
            // 把原始的signature放入文件数组，这样重新提交时也能保存回去
            let binaryString = window.atob(data.data.Image);
            let binaryLen = binaryString.length;
            let bytes = new Uint8Array(binaryLen);
            for (let i = 0; i < binaryLen; i++) {
              let ascii = binaryString.charCodeAt(i);
              bytes[i] = ascii;
            }

            let blob = new Blob([bytes], { type: 'application/octet-stream' });
            let file = new File([blob], 'image.png', { type: 'application/octet-stream', lastModified: Date.now() });
            fileList.push(file);
          }
          pageComponent.setState({ imagePreview: data.data.Image, fileList });
        } else {
          pageComponent.setState({ imagePreview: null, fileList: [] });
        }
        pageComponent.formRef.current?.setFieldsValue(data.data);
        pageComponent.setState({ currentDataKey: data.data.key, type: data.data.Type });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//获取下拉菜单数据源
export function getSystemTextFontDataSource({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('/System/SelectOption/GetSystemTextFontList')
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let dataSource = data.data;
          let componentDataSource = { ...pageComponent.state.componentDataSource };
          componentDataSource.SystemTextFont = dataSource;
          pageComponent.setState({ componentDataSource });
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

export function getCompanyUserDataSource({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .get('/Admin/CompanyUser/GetSelectOptionList')
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          let dataSource = data.data;
          let componentDataSource = { ...pageComponent.state.componentDataSource };
          componentDataSource.CompanyUser = dataSource;
          pageComponent.setState({ componentDataSource });
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}
